import script from "./userPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./userPopover.vue?vue&type=script&setup=true&lang=js"

import "./userPopover.vue?vue&type=style&index=0&id=a616f692&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a616f692"]])

export default __exports__